import { toEditableMaxDays } from "../maxDays/maxDays";
import { EditableLiftAccessRules, LiftAccessRules } from "./models";
import { toEditableBlackoutDateRange } from "../blackoutDateRange/blackoutDateRange";
import { toEditableBlackoutDayOfWeekRuleGroups } from "../blackoutDayOfWeek/blackoutDayOfWeek";
import {
  createEmptyEditableEffectiveDateRangeRule,
  toEditableEffectiveDateRange,
} from "../effectiveDateRange/effectiveDateRange";

export function toEditableLiftAccessRules(
  rules: LiftAccessRules,
): EditableLiftAccessRules {
  const effectiveDateRangeRules =
    // An effective date range rules is required, so if there are no existing rules create a default empty rule
    rules.effectiveDateRangeRules.length > 0
      ? rules.effectiveDateRangeRules.map(toEditableEffectiveDateRange)
      : [createEmptyEditableEffectiveDateRangeRule()];

  return {
    ...rules,
    maxDaysRules: rules.maxDaysRules.map(toEditableMaxDays),
    blackoutDateRangeRules: rules.blackoutDateRangeRules.map(
      toEditableBlackoutDateRange,
    ),
    blackoutDayOfWeekRuleGroups: toEditableBlackoutDayOfWeekRuleGroups(rules.blackoutDayOfWeekRules),
    effectiveDateRangeRules,
  };
}
